<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="single container-max page-content">
                <div class="row position-relative">
                    <div class="mt-5 col-12 col-md-7">
                        <slot name="image-carousel"></slot>
                    </div>

                    <div class="col-12 col-md-5 mt-md-5 single-sticky-top">
                        <div>
                            <!-- START SINGLEITEM_DETAILS -->
                            <div class="producertag h6 producer text-muted"
                                v-if="currentVariation.filter.hasManufacturer">
                                {{
                                    currentVariation.item.manufacturer
                                        .externalName
                                }}
                            </div>

                            <h1 class="h2 title" data-testing="item-name">
                                <span>
                                    {{ currentVariation | itemName }}
                                </span>
                            </h1>

                            <slot name="tag-list"></slot>

                            <p class="single-description" v-if="
                                isShortDescriptionActive &&
                                currentVariation.texts.shortDescription !==
                                ''
                            " v-html="currentVariation.texts.shortDescription
                                "></p>

                            <hr />

                            <div class="mb-3">
                                <span class="articlenumber small text-muted">
                                    <b>{{
                                        $translate(
                                            "Ceres::Template.singleItemNumber"
                                        )
                                    }}
                                    </b>
                                    <span>{{ currentVariation.item.id }}</span>
                                </span>
                            </div>

                            <!-- Variation -->
                            <div class="mb-3" v-if="
                                attributes.length ||
                                Object.keys(units).length
                            ">
                                <variation-select></variation-select>
                            </div>
                            <!-- /Variation -->

                            <!-- Item Bundle -->
                            <item-bundle v-if="
                                currentVariation.variation.bundleType ===
                                'bundle'
                            " :bundle-type="currentVariation.variation.bundleType
                                " :bundle-components="currentVariation.bundleComponents
                                    "></item-bundle>
                            <!-- /Item Bundle -->

                            <slot name="before-price"></slot>

                            <div v-if="
                                currentVariation.filter.isSalable &&
                                variationGroupedProperties.length
                            ">
                                <order-property-list></order-property-list>
                            </div>

                            <item-price :show-cross-price="isRecommendedPriceActive
                                "></item-price>
                            <div class="graduated-price__wrapper">
                                <graduated-prices></graduated-prices>
                            </div>

                            <slot name="after-price"></slot>

                            <item-availability></item-availability>

                            <div class="my-3">
                                <div class="w-100">
                                    <slot name="before-add-to-basket"></slot>
                                </div>
                                <div v-if="downLoadLink" class="add-to-basket-container">
                                    <a type="button" class="btn btn-block btn-primary btn-appearance" :href="'https://cdn02.plentymarkets.com/oueuwrwk0stw/propertyItems/' +
                                        downLoadLink
                                        " target="_blank">
                                        Download
                                    </a>
                                </div>

                                <div>
                                    <div v-if="
                                        currentVariation.item.itemType ===
                                        'set'
                                    " class="alert alert-info w-100">
                                        {{
                                            $translate(
                                                "Ceres::Template.singleItemSetInfo"
                                            )
                                        }}
                                    </div>
                                    <div v-else class="my-3 col-12 col-sm-7 col-md-12 col-lg-8">
                                        <add-to-basket :variation-id="currentVariation.variation.id
                                            " :is-salable="!!currentVariation.filter &&
                                                currentVariation.filter
                                                    .isSalable
                                                " :has-children="!!currentVariation.filter &&
                                                    currentVariation.filter
                                                        .hasActiveChildren
                                                    " :interval-quantity="currentVariation.variation
                                                        .intervalOrderQuantity || 1
                                                        " :minimum-quantity="currentVariation.variation
                                                        .minimumOrderQuantity
                                                        " :maximum-quantity="!!currentVariation.variation
                                                        .maximumOrderQuantity &&
                                                        currentVariation.variation
                                                            .maximumOrderQuantity > 0
                                                        ? currentVariation.variation
                                                            .maximumOrderQuantity
                                                        : null
                                                        " :order-properties="currentVariation.properties.filter(
                                                        function (prop) {
                                                            return prop.property
                                                                .isOderProperty;
                                                        }
                                                    )
                                                        " :has-order-properties="currentVariation.hasOrderProperties
                                                        " :has-required-order-property="currentVariation.hasRequiredOrderProperty
                                                        " :use-large-scale="false" :show-quantity="true" :item-url="currentVariation | itemURL
                                                        " :is-variation-selected="isVariationSelected &&
                                                        currentVariation.filter
                                                            .isSalable
                                                        " :has-price="currentVariation
                                                        | hasItemDefaultPrice
                                                        ">
                                        </add-to-basket>
                                    </div>
                                </div>
                                <div class="w-100">
                                    <slot name="after-add-to-basket"></slot>
                                </div>
                            </div>

                            <div v-if="isWishListEnabled" class="row">
                                <div class="col-12 wishlist-wrapper">
                                    <add-to-wish-list :variation-id="currentVariation.variation.id
                                        "></add-to-wish-list>
                                </div>
                            </div>

                            <div class="shipping__wrapper">
                                <div class="shipping__headline">
                                    {{
                                        $translate(
                                            "ODZwergentraeume::Template.shippingHeadline"
                                        )
                                    }}
                                </div>
                                <div class="shipping__text shipping__text--de" v-if="
                                    Math.round(
                                        currentVariation.prices.default
                                            .price.value * 100
                                    ) /
                                    100 <
                                    300
                                ">
                                    {{
                                        $translate(
                                            "ODZwergentraeume::Template.shippingDe"
                                        )
                                    }}
                                </div>
                                <div class="shipping__text shipping__text--de-free" v-else>
                                    {{
                                        $translate(
                                            "ODZwergentraeume::Template.shippingDeFree"
                                        )
                                    }}
                                </div>
                            </div>
                            <!-- ./ITEM DETAIL -->

                            <slot name="additional-content-after-add-to-basket"></slot>

                            <hr />

                            <div v-if="filteredVariationProperties.length > 0" class="properties__wrapper">
                                <div v-for="property in filteredVariationProperties" class="properties" :class="{
                                    'd-block':
                                        property.cast === 'multiSelection',
                                }">
                                    <strong v-if="property.names" class="properties__property-name">{{
                                        property.names.name }}</strong>
                                    <span v-if="
                                        property.values &&
                                        property.cast == 'file'
                                    " class="properties__property-value"><a :href="'https://cdn02.plentymarkets.com/oueuwrwk0stw/propertyItems/' +
                                        property.values.value
                                        " target="_blank">Download</a></span>
                                    <template v-else-if="property.values">
                                        <template v-if="
                                            property.cast ===
                                            'multiSelection'
                                        ">
                                            <div v-for="val in property.values" v-html="val.value"
                                                class="properties__property-value"></div>
                                        </template>
                                        <span v-else v-html="property.values.value"
                                            class="properties__property-value"></span>
                                    </template>
                                </div>
                            </div>

                            <slot name="additional-content-after-vat"></slot>
                            <!-- END SINGLEITEM_DETAILS -->
                        </div>
                    </div>

                    <div class="col-12 col-md-7">
                        <!-- ITEM DESCRIPTION -->
                        <div class="my-5">
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="tab" class="nav-item" v-if="isDescriptionTabActive">
                                    <a class="nav-link active" data-toggle="tab" :href="'#details-' +
                                        currentVariation.variation.id
                                        ">{{
                                            $translate(
                                                "Ceres::Template.singleItemDescription"
                                            )
                                        }}</a>
                                </li>

                                <li role="tab" class="nav-item d-none" v-if="isTechnicalDataTabActive">
                                    <a :class="{
                                        active:
                                            !isDescriptionTabActive &&
                                            isTechnicalDataTabActive,
                                    }" class="nav-link" data-toggle="tab" :href="'#data-' +
                                        currentVariation.variation.id
                                        ">{{
                                            $translate(
                                                "Ceres::Template.singleItemTechnicalData"
                                            )
                                        }}</a>
                                </li>

                                <li class="nav-item d-none" role="tab">
                                    <a :class="{
                                        active:
                                            !isDescriptionTabActive &&
                                            !isTechnicalDataTabActive,
                                    }" class="nav-link" data-toggle="tab" href="#assessments-details">{{
                                        $translate(
                                            "Ceres::Template.singleItemMoreDetails"
                                        )
                                    }}</a>
                                </li>

                                <slot name="add-detail-tabs"></slot>
                            </ul>

                            <div class="overflow-hidden tab-content">
                                <div class="overflow-auto tab-pane active" :id="'details-' +
                                    currentVariation.variation.id
                                    " role="tabpanel" v-if="isDescriptionTabActive">
                                    <div class="my-4" v-html="currentVariation.texts.description
                                        "></div>

                                    <hr class="desc-line" />

                                    <slot name="properties"></slot>

                                    <hr class="desc-line" />

                                    <div class="my-4" v-html="currentVariation.texts.technicalData
                                        "></div>


                                    <a v-if="hasManufacturerDataPart2 || hasManufacturerDataPart1"
                                        data-target="#eusafety" class="mt-5 d-block" data-toggle="modal" href="#">
                                        ⓘ Herstellerinformationen
                                    </a>
                                </div>

                                <div :class="{
                                    active:
                                        !isDescriptionTabActive &&
                                        isTechnicalDataTabActive,
                                }" class="overflow-auto tab-pane d-none" :id="'data-' + currentVariation.variation.id
                                    " role="tabpanel" v-if="isTechnicalDataTabActive">
                                    <div class="my-4" v-html="currentVariation.texts.technicalData
                                        "></div>
                                </div>

                                <div :class="{
                                    active:
                                        !isDescriptionTabActive &&
                                        !isTechnicalDataTabActive,
                                }" class="overflow-auto tab-pane d-none" id="assessments-details" role="tabpanel">
                                    <div class="my-4">
                                        <table class="table table-striped table-hover table-sm">
                                            <tbody>
                                                <tr v-if="
                                                    itemConfig.includes(
                                                        'item.id'
                                                    ) ||
                                                    itemConfig.includes(
                                                        'all'
                                                    )
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemId"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .item.id
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    currentVariation.item
                                                        .condition &&
                                                    currentVariation.item
                                                        .condition.names
                                                        .name !== '' &&
                                                    (itemConfig.includes(
                                                        'item.condition'
                                                    ) ||
                                                        itemConfig.includes(
                                                            'all'
                                                        ))
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemCondition"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .item.condition
                                                                .names.name
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    itemConfig.includes(
                                                        'item.age_rating'
                                                    ) ||
                                                    itemConfig.includes(
                                                        'all'
                                                    )
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemAge"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .item
                                                                .ageRestriction
                                                            | ageRestriction
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    currentVariation
                                                        .variation
                                                        .externalId !==
                                                    '' &&
                                                    (itemConfig.includes(
                                                        'item.external_id'
                                                    ) ||
                                                        itemConfig.includes(
                                                            'all'
                                                        ))
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemExternalVariationId"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .variation
                                                                .externalId
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    currentVariation
                                                        .variation.model !==
                                                    '' &&
                                                    (itemConfig.includes(
                                                        'item.variation_model'
                                                    ) ||
                                                        itemConfig.includes(
                                                            'all'
                                                        ))
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemModel"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .variation.model
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    currentVariation.filter
                                                        .hasManufacturer &&
                                                    currentVariation.item
                                                        .manufacturer
                                                        .externalName !==
                                                    '' &&
                                                    (itemConfig.includes(
                                                        'item.manufacturer'
                                                    ) ||
                                                        itemConfig.includes(
                                                            'all'
                                                        ))
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemManufacturer"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .item
                                                                .manufacturer
                                                                .externalName
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    currentVariation.item
                                                        .producingCountry &&
                                                    currentVariation.item
                                                        .producingCountry
                                                        .names.name !==
                                                    '' &&
                                                    (itemConfig.includes(
                                                        'item.producerCountry'
                                                    ) ||
                                                        itemConfig.includes(
                                                            'all'
                                                        ))
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemManufacturingCountry"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .item
                                                                .producingCountry
                                                                .names.name
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    currentVariation.unit &&
                                                    (itemConfig.includes(
                                                        'item.variationBase_content'
                                                    ) ||
                                                        itemConfig.includes(
                                                            'all'
                                                        ))
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemContent"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .unit.content
                                                        }}
                                                        {{
                                                            currentVariation
                                                                .unit.names.name
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    currentVariation
                                                        .variation
                                                        .weightG !== '' &&
                                                    (itemConfig.includes(
                                                        'item.weightG'
                                                    ) ||
                                                        itemConfig.includes(
                                                            'all'
                                                        ))
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemWeight"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .variation
                                                                .weightG
                                                        }}
                                                        g
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    currentVariation
                                                        .variation
                                                        .weightNetG !==
                                                    '' &&
                                                    (itemConfig.includes(
                                                        'item.weightNetG'
                                                    ) ||
                                                        itemConfig.includes(
                                                            'all'
                                                        ))
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemNetWeight"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .variation
                                                                .weightNetG
                                                        }}
                                                        g
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    itemConfig.includes(
                                                        'item.variation_dimensions'
                                                    ) ||
                                                    itemConfig.includes(
                                                        'all'
                                                    )
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemDimensions"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        <span>{{
                                                            currentVariation
                                                                .variation
                                                                .lengthMM
                                                        }}</span>&times;<!--
                                                --><span>{{
                                                    currentVariation
                                                        .variation
                                                        .widthMM
                                                }}</span>&times;<!--
                                                --><span>{{
                                                    currentVariation
                                                        .variation
                                                        .heightMM
                                                }}</span>
                                                        mm
                                                    </td>
                                                </tr>

                                                <tr v-if="
                                                    currentVariation.item
                                                        .customsTariffNumber !==
                                                    '' &&
                                                    (itemConfig.includes(
                                                        'item.customs_tariff_number'
                                                    ) ||
                                                        itemConfig.includes(
                                                            'all'
                                                        ))
                                                ">
                                                    <td>
                                                        {{
                                                            $translate(
                                                                "Ceres::Template.singleItemCustomsTariffNumber"
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            currentVariation
                                                                .item
                                                                .customsTariffNumber
                                                        }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <slot name="add-detail-tabs-content"></slot>
                            </div>
                        </div>
                        <!-- ./ITEM DESCRIPTION -->
                    </div>
                </div>

                <slot name="dropzone"></slot>
                <div class="single-item-list-container">
                    <slot name="item-list-container"></slot>
                </div>
                <slot name="feedback-container"></slot>
            </div>
        </slot>
        <div id="eusafety-wrapper">
            <div class="modal fade" id="eusafety" tabindex="-1" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title h3">
                                Herstellerinformationen
                            </div>
                            <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span
                                    aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div>

                                <div v-if="hasManufacturerDataPart1">
                                    <div v-if="manufacturerData.name">
                                        {{ manufacturerData.name }}
                                    </div>
                                    <div v-if="manufacturerData.street || manufacturerData.houseNo">
                                        {{ manufacturerData.street }} {{ manufacturerData.houseNo }}
                                    </div>
                                    <div v-if="manufacturerData.postcode || manufacturerData.town">
                                        {{ manufacturerData.postcode }} {{ manufacturerData.town }}
                                    </div>
                                    <div v-if="manufacturerCountry != ''">
                                        {{ manufacturerCountry }}
                                    </div>
                                    <div v-if="manufacturerData.email">
                                        {{ manufacturerData.email }}
                                    </div>
                                </div>


                                <div class="mt-4" v-if="hasManufacturerDataPart2">
                                    <div class="h4">EU-Verantwortlicher</div>
                                    <div v-if="manufacturerData.responsibleName">{{ manufacturerData.responsibleName
                                        }}</div>
                                    <div
                                        v-if="manufacturerData.responsibleStreet || manufacturerData.responsibleHouseNo">
                                        {{ manufacturerData.responsibleStreet
                                        }} {{
                                            manufacturerData.responsibleHouseNo }}</div>
                                    <div
                                        v-if="manufacturerData.responsiblePostCode || manufacturerData.responsibleTown">
                                        {{ manufacturerData.responsiblePostCode }} {{ manufacturerData.responsibleTown
                                        }}
                                    </div>
                                    <div v-if="responsibleManufacturerCountry != ''">{{ responsibleManufacturerCountry
                                        }}
                                    </div>
                                    <div v-if="manufacturerData.responsibleEmail">{{ manufacturerData.responsibleEmail
                                        }}</div>
                                </div>

                                <div v-if="currentVariation.barcodes" class="mt-2 pt-2 border-top">EAN: {{
                                    currentVariation.barcodes[0].code }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";
import { isNullOrUndefined } from "ceres/app/helper/utils";

export default {
    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0,
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false,
        },
        showNetPrices: {
            type: Boolean,
            default: false,
        },
        isWishListEnabled: {
            type: Boolean,
            default: false,
        },
        itemId: {
            type: Number,
            required: true,
        },
        afterKey: Object,
    },

    provide() {
        return {
            itemId: this.$props.itemId,
        };
    },

    jsonDataFields: ["itemData", "attributesData", "variations"],

    computed: {
        manufacturerData() {
            return this.$store.getters.currentItemVariation.item.manufacturer;
        },
        manufacturerCountry() {
            if (this.manufacturerData && this.manufacturerData.countryObject && this.manufacturerData.countryObject.names) {
                for (let key in this.manufacturerData.countryObject.names) {
                    if (this.manufacturerData.countryObject.names[key].language === "de") {
                        return this.manufacturerData.countryObject.names[key].name;
                    }
                }
            }
            return ""
        },
        hasManufacturerDataPart1() {
            if (this.manufacturerData.name || this.manufacturerData.street || this.manufacturerData.houseNo || this.manufacturerData.postCode || this.manufacturerData.responsibleTown || this.manufacturerCountry !== "" || (this.manufacturerData.email && this.manufacturerData.email !== '') || this.manufacturerData.phoneNo) {
                return true;
            }
        },
        hasManufacturerDataPart2() {
            if (this.manufacturerData.responsibleName || this.manufacturerData.responsibleStreet || this.manufacturerData.responsibleHouseNo || this.manufacturerData.responsiblePostCode || this.manufacturerData.responsibleTown || this.responsibleManufacturerCountry !== "" || (this.manufacturerData.responsibleEmail && this.manufacturerData.responsibleEmail !== '')) {
                return true;
            }
        },

        responsibleManufacturerCountry() {
            if (this.manufacturerData && this.manufacturerData.responsibleCountryObject && this.manufacturerData.responsibleCountryObject.names) {
                for (let key in this.manufacturerData.responsibleCountryObject.names) {
                    if (this.manufacturerData.responsibleCountryObject.names[key].language === "de") {
                        return this.manufacturerData.responsibleCountryObject.names[key].name;
                    }
                }
            }
            return ""
        },
        filteredVariationProperties() {
            let filteredProps = [];
            for (let key in this.currentVariation.variationProperties) {
                for (let key2 in this.currentVariation.variationProperties[
                    key
                ].properties) {
                    if (
                        this.currentVariation.variationProperties[key]
                            .properties[key2].id !== 26
                    ) {
                        filteredProps.push(
                            this.currentVariation.variationProperties[key]
                                .properties[key2]
                        );
                    }
                }
            }

            return filteredProps;
        },

        itemConfig() {
            return App.config.item.itemData;
        },

        isDescriptionTabActive() {
            return (
                (App.config.item.itemData.includes("item.description") ||
                    App.config.item.itemData.includes("all")) &&
                !!this.currentVariation.texts.description.length
            );
        },

        isRecommendedPriceActive() {
            return (
                App.config.item.itemData.includes(
                    "item.recommendedPrice"
                ) || App.config.item.itemData.includes("all")
            );
        },

        isShortDescriptionActive() {
            return (
                App.config.item.itemData.includes(
                    "item.shortDescription"
                ) || App.config.item.itemData.includes("all")
            );
        },

        hasShippingCostsCategoryId() {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive() {
            return (
                (App.config.item.itemData.includes("item.technical_data") ||
                    App.config.item.itemData.includes("all")) &&
                !!this.currentVariation.texts.technicalData.length
            );
        },

        variationGroupedProperties() {
            return this.$store.getters[
                `${this.itemId}/variationGroupedProperties`
            ];
        },

        variationMissingProperties() {
            return this.$store.getters[
                `${this.itemId}/variationMissingProperties`
            ];
        },

        currentVariation() {
            return get(
                this.$store.state,
                `items[${this.itemId}].variation.documents[0].data`
            );
        },

        isVariationSelected() {
            return get(
                this.$store.state,
                `items[${this.itemId}].variationSelect.isVariationSelected`
            );
        },

        attributes() {
            return get(
                this.$store.state,
                `items[${this.itemId}].variationSelect.attributes`
            );
        },

        units() {
            return get(
                this.$store.state,
                `items[${this.itemId}].variationSelect.units`
            );
        },
        isItemSet() {
            return this.$store.state.items.isItemSet;
        },
        b2bCustomerClassArr() {
            return App.b2bCustomerClassArr;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        user() {
            return this.$store.state.user;
        },
        downLoadLink() {
            return this.findProperty(12);
        },
    },

    created() {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(
            `${this.itemId}/setPleaseSelectVariationId`,
            this.pleaseSelectOptionVariationId
        );
    },

    mounted() {
        this.$nextTick(() => {
            this.$store.dispatch(
                `${this.itemId}/variationSelect/setVariationSelect`,
                {
                    itemId: this.itemId,
                    attributes: this.attributesData,
                    variations: this.variations,
                    initialVariationId: this.currentVariation.variation.id,
                    isPleaseSelectOption: this.initPleaseSelectOption,
                    afterKey: this.afterKey,
                }
            );

            if (this.isItemSet) {
                this.$store.dispatch("initSetComponents", this.itemData);
            }
        });

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () =>
            this.hydrateChildren(this.$children)
        );
    },

    methods: {
        findProperty(propID) {
            if (
                this.currentVariation &&
                typeof this.currentVariation.variationProperties !=
                "undefined" &&
                this.currentVariation.variationProperties.length > 0
            ) {
                const props =
                    this.currentVariation.variationProperties[0].properties;
                const propData = props.find((p) => p.id === propID);
                if (propData && propData.values && propData.values.value) {
                    return propData.values.value;
                }
            }
            return "";
        },
        getDataField(field) {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter) {
            if (!isNullOrUndefined(this.$options.filters[filter])) {
                return this.$options.filters[filter](
                    this.getDataField(field)
                );
            }

            return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes) {
            nodes.forEach((component) => {
                if (component.$options.name === "lazy-hydrate") {
                    component.hydrate();
                } else if (component.$children.length) {
                    this.hydrateChildren(component.$children);
                }
            });
        },
    },
};
</script>
